import './App.css';
import Header from './components/Header';
import Footer from './components/footer/Footer';
import Experience from './components/experience/Experience';
import Contact from './components/contact/Contact';
import About from './components/about/About';
import Service from './components/services/Service';
import Project from './components/projects/Projects';
import Credentials from './components/credentials/Credentials';
import Testimonial from './components/testimonials/Testimonials';


const  App = () => {
  return (
    <>
      <Header />
      <Credentials />
      <About />
      <Experience />
      <Service />
      <Project />
      <Testimonial />
      <Contact />
      <Footer />
    </>
  )
}

export default App;
